import AuthorizedForm from './AuthorizedForm.vue';

export default AuthorizedForm;
